import type { BadgeVariant } from "../../../ui/badge/badge.tsx";

export function probationStatusBadgeVariant(status: string | undefined): BadgeVariant {
  const u = (status ?? "").toUpperCase();
  if (u === "APPROVED" || u === "COMPLETED") return "success";
  if (u === "REJECTED") return "danger";
  if (u === "IN_PROGRESS" || u === "PENDING" || u === "EXTEND") return "warning";
  return "neutral";
}
